import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PriorityViewModel } from 'app/models/PriorityViewModel';
import { TicketService } from '../../../services/ticket.service';
import { finalize } from 'rxjs';

@Component({
	selector: 'app-components-managecustomer-opentickets',
	templateUrl: './OpenTickets.component.html'
})
export class OpenTicketsComponent implements OnInit {
    ko = ko;
    moment = moment;
    Date = Date;
    @Input() customer: Boo.Objects.Customer;
    @Output() refreshCustomer = new EventEmitter<void>();
    @Output() reloadNotes = new EventEmitter<void>();
    public isLoading: boolean;
    public tickets: Boo.Objects.TicketPartial[];

    constructor(private ticketService: TicketService) { }

    ngOnInit(): void {
        this.isLoading = false;
        this.tickets = [];

        this.loadTickets();
    }

    public loadTickets() {
        this.isLoading = true;

        return this.ticketService.getOpen(this.customer.CustomerId)
            .pipe(finalize(() => this.isLoading = false))
            .subscribe((tickets: Boo.Objects.TicketPartial[]) => {
                this.tickets = tickets;
            });
    }

    public newTicket(): void {
        PriorityViewModel.show('app-components-managecustomer-newticket', { customer: ko.mapping.fromJS(this.customer) })
            .always((result: app.ticket.interfaces.IPriorityViewResult) => {
                this.loadTickets();
            });
    }

    public editTicket(ticket: Boo.Objects.TicketPartial): void {
        PriorityViewModel.show('app-components-ticket', { customer: ko.mapping.fromJS(this.customer), ticketId: ticket.TicketId })
            .always((result: app.ticket.interfaces.IPriorityViewResult) => {
                if (result.modifiedDataFlags && result.modifiedDataFlags.customer) {
                    this.refreshCustomer.emit();
                }

                this.loadTickets();
                this.reloadNotes.emit();
            });
    }
}
